const isBrowser = typeof window !== "undefined";
const onLocal3000 =
  isBrowser && window.location.hostname === "localhost" && window.location.port === "3000";
const API_BASE = process.env.REACT_APP_API_URL || (onLocal3000 ? "http://localhost:3001" : "");

function withApiBase(path) {
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  return `${API_BASE}${path}`;
}

async function apiJson(path, options = {}) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 15000);
  const res = await fetch(withApiBase(path), {
    ...options,
    credentials: "include",
    signal: controller.signal,
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
  }).finally(() => clearTimeout(timeout));
  const data = await res.json().catch(() => null);
  if (!res.ok || data?.ok === false) {
    const error = data?.error || res.statusText || "request_failed";
    throw new Error(error);
  }
  return data;
}

export function loadDefaultFifaRoom() {
  return apiJson("/api/fifa/default");
}

export function loadPublicFifaPreview() {
  return apiJson("/api/fifa-public");
}

export function loadMyFifaRooms() {
  return apiJson("/api/fifa/my-rooms");
}

export function loadFifaRoom(code) {
  return apiJson(`/api/fifa/rooms/${encodeURIComponent(code)}`);
}

export function loadFifaLeagueDetails(code) {
  return apiJson(`/api/fifa/rooms/${encodeURIComponent(code)}/details`);
}

export function createFifaRoom(payload) {
  return apiJson("/api/fifa/rooms", {
    method: "POST",
    body: JSON.stringify(payload || {}),
  });
}

export function updateFifaRoom(code, payload) {
  return apiJson(`/api/fifa/rooms/${encodeURIComponent(code)}`, {
    method: "PATCH",
    body: JSON.stringify(payload || {}),
  });
}

export function updateFifaTournamentSpecials(code, payload) {
  return apiJson(
    `/api/fifa/rooms/${encodeURIComponent(code)}/tournament-specials`,
    {
      method: "PATCH",
      body: JSON.stringify(payload || {}),
    }
  );
}

export function joinFifaRoom(code) {
  return apiJson(`/api/fifa/rooms/${encodeURIComponent(code)}/join`, {
    method: "POST",
    body: JSON.stringify({}),
  });
}

export function decideFifaHistoricalImport(code, participantUserId, approved) {
  return apiJson(
    `/api/fifa/rooms/${encodeURIComponent(code)}/historical-imports/${encodeURIComponent(participantUserId)}`,
    {
      method: "POST",
      body: JSON.stringify({ approved: approved === true }),
    }
  );
}

export function saveFifaPrediction(code, matchId, payload) {
  return apiJson(`/api/fifa/rooms/${encodeURIComponent(code)}/predictions/${encodeURIComponent(matchId)}`, {
    method: "PUT",
    body: JSON.stringify(payload || {}),
  });
}

export function saveFifaSpecialPrediction(code, payload) {
  return apiJson(
    `/api/fifa/rooms/${encodeURIComponent(code)}/special-prediction`,
    {
      method: "PUT",
      body: JSON.stringify(payload || {}),
    }
  );
}

export function saveFifaSpecialResult(payload) {
  return apiJson("/api/fifa/special-result", {
    method: "PUT",
    body: JSON.stringify(payload || {}),
  });
}

export function saveFifaResult(code, matchId, payload) {
  return apiJson(`/api/fifa/rooms/${encodeURIComponent(code)}/matches/${encodeURIComponent(matchId)}/result`, {
    method: "PUT",
    body: JSON.stringify(payload || {}),
  });
}
